export const KNOWLEDGE_BASE_LINK: string = 'https://knowledgebase.cloud.market';
